import { useFormContext } from 'react-hook-form';
import {
  FormField,
  FormItem,
  FormMessage,
  Label,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from '@@/ui/primitives';

export function ConnectResourceConstraints() {
  const form = useFormContext();

  return (
    <div className='flex flex-col gap-4 p-4'>
      <div className='flex flex-col gap-1'>
        <h4 className='text-sm font-semibold text-neutral-950'>Amazon Connect Resource constraints</h4>
        <p className='text-xs text-neutral-600'>Configure which Amazon Connect resource type this field will store.</p>
      </div>

      <FormField
        control={form.control}
        name='definition.resourceType'
        render={({ field }) => (
          <FormItem className='flex flex-col gap-2'>
            <Label htmlFor='resource-type' className='text-sm! text-neutral-950'>
              Type
            </Label>
            <Select value={field.value} onValueChange={field.onChange} disabled={field.disabled}>
              <SelectTrigger id='resource-type' className='text-sm! font-medium! bg-white text-neutral-950 shadow-none'>
                <SelectValue placeholder='Select resource type...' />
              </SelectTrigger>
              <SelectContent className='text-sm font-medium'>
                <SelectItem value='QUEUE'>Queue</SelectItem>
                <SelectItem value='CONTACT_FLOW'>Contact Flow</SelectItem>
                <SelectItem value='CONTACT_FLOW_MODULE'>Contact Flow Module</SelectItem>
                <SelectItem value='PROMPT'>Prompt</SelectItem>
                <SelectItem value='PHONE_NUMBER'>Phone Number</SelectItem>
              </SelectContent>
            </Select>
            <FormMessage className='text-sm text-red-950' />
          </FormItem>
        )}
      />
    </div>
  );
}
